import service from '@/store/services/fms/driver_dp-service';

const state = {
  list: {},
  driver_dp: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, driver_dp) => {
    state.driver_dp = driver_dp;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },


  get({commit, dispatch}, params) {
    return service.get(params)
      .then((driver_dp) => { commit('SET_RESOURCE', driver_dp); });
  },

};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  driver_dp: state => state.driver_dp,
  page: state => state.meta.page,
};
 
const driver_dp = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default driver_dp;
